import { Fragment, type FC } from "react";
import { Badge, Divider, Stack } from "@mantine/core";
import { IconStack2 } from "@tabler/icons-react";
import { type Order } from "@jasper/shared";
import { getDisplayedProducts } from "../order-page.utils";
import { OrderDetailCard } from "./OrderDetailCard";
import { OrderProductLine } from "./OrderProductLine";
import { getProductsCountLabel } from "./order-page-v2.utils";

type OrderProductsCardProps = {
  order: Order;
};

export const OrderProductsCard: FC<OrderProductsCardProps> = ({ order }) => (
  <OrderDetailCard
    icon={IconStack2}
    title="Prothèses de la commande"
    rightSection={
      <Badge variant="tag" color="ink" tt="none">
        {getProductsCountLabel(order.products)}
      </Badge>
    }
  >
    <Stack gap={0}>
      {getDisplayedProducts(order.products).map((product, index) => (
        <Fragment key={product.id}>
          {index > 0 && <Divider color="ink.0" />}
          <OrderProductLine product={product} />
        </Fragment>
      ))}
    </Stack>
  </OrderDetailCard>
);
